import { ensureEditOrganizationIsValid, type OrganizationRepository } from '@/core/organization'
import type { UseCase } from '@/core/shared'

export const edit: UseCase<OrganizationRepository, 'edit'> = repository => {
  return async (organization) => {
    await ensureEditOrganizationIsValid(organization)
    await repository.edit(organization)
  }
}
